import { render, staticRenderFns } from "./FormularioContacto.vue?vue&type=template&id=130da326&scoped=true"
import script from "./FormularioContacto.vue?vue&type=script&lang=js"
export * from "./FormularioContacto.vue?vue&type=script&lang=js"
import style0 from "./FormularioContacto.vue?vue&type=style&index=0&id=130da326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130da326",
  null
  
)

export default component.exports